import { Diagram, DiagramEventName } from 'gojs';

export type ToggleAction = 'expand' | 'collapse';

export const toggleGroups = (diagram: Diagram, action: ToggleAction): void => {
  diagram.commit((diagramRef) => {
    diagramRef.findTopLevelGroups().each((group) => {
      if (group.memberParts.count > 0) {
        group[`${action}SubGraph`]();
      }
    });
  }, `${action} all top level groups`);

  const event: DiagramEventName = action === 'expand' ? 'SubGraphExpanded' : 'SubGraphCollapsed';
  diagram.raiseDiagramEvent(event);
};
